const VERSION = "8.0.3";
export {
  VERSION
};
